import { PageTitleProps } from './types';
import * as S from './styles';

const PageTitle = ({ title }: PageTitleProps): JSX.Element => <S.PageTitle title={title}>{title}</S.PageTitle>;

export default PageTitle;
